"use client";
import { usePathname,  } from 'next/navigation';
import { useMedia } from "./useMedia";
import { useSiblingStore } from './useSiblingStore';

export const useDtpgid = (path: string) => {
    const isMobile = useMedia('mobile');
    const  mobilePage = useSiblingStore(state => state.eventTracking.mobilePage[path]);
    const  pcPage = useSiblingStore(state => state.eventTracking.pcPage[path]);
    return isMobile ? mobilePage: pcPage;
}

export const usePathDtpgid = (keyPath?: string) => {
    const pathname = usePathname();
    return useDtpgid(keyPath || pathname) || {};
}